import Vue from 'vue'
import to from 'await-to-js'
import client from '@/api/client'
import HOMEPAGE_QUERY from '@/api/gql/homepage/query/homepage.gql'

const DEFAULT_TEMPLATE = 'C'

const getCategorySliderData = vm => {
  // TODO: #3581 ⁃ Provide category slider data via GraphQl
  // TODO: #3407 ⁃ Add final hard-coded data for category slider
  const getFullUrl = vm.$store.getters['page/getFullUrl']
  const ctaText = vm.$t('discover_cta')
  const CATEGORY_SLIDER_DATA = [
    {
      title: vm.$t('latest'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/2VKshQrNktzc5bdxmRIlxc/42ddd9d31aa1693bc86e9f0c285f45c9/Category_Slider-SS22-New_Arrivals.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/?release_date=new-arrivals') }],
    },
    {
      title: vm.$t('cloud_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/9AcxCn5hA9JgdzNjdvnWV/3e95dbd41c5aa718a330ba103d2d906c/CategorySlider_Clouds.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/cloud') }],
    },
    {
      title: vm.$t('shoe_finder'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/4mRASkbDi70xmhAq7U4JE2/fe330a4c176d6b1d15651aa63f0c036c/CategorySlider_ShoeFinder.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/shoe-finder') }],
    },
    {
      title: vm.$t('cloudnova_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/1m28luOwTowpZhmn1Mr4Zm/dd07bcbb88cb08aa85f56ed0cb59c7bc/CategorySlider_Cloudnova.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/cloudnova') }],
    },
    {
      title: vm.$t('road_running'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/4Rbmi9NAID17nvgZfWaNCy/3abaddc443258ced8730f38df82efae5/CategorySlider_Running.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/shoes/road') }],
    },
    {
      title: vm.$t('home_workout'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/66YKqnB72eF0Ejnu9Rg8PR/e06d61068c49a60b3a5fdaf44c9dff9f/CategorySlider_HomeWorkouts.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/homeworkout') }],
    },
    {
      title: vm.$t('outdoor_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/7sem8NBpx3P0jTYC4QHjN9/c94264a96391138806f6c55a9bed6539/CategorySlider_Outdoors.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/outdoor') }],
    },
    {
      title: vm.$t('apparel'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/2T3HPlueDW8srAMD6y5aR1/2ca519d8c8ab9b6567c8044e1120e6b7/Category_Slider-SS22-Apparel.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/apparel') }],
    },
    {
      title: vm.$t('waterproof_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/1sL6a8NsTNsSMiZNcuzIND/3e5510a06673cb13236c513db2579406/CategorySlider_Waterproof.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/no-excuses') }],
    },
    {
      title: vm.$t('bestsellers'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/4vbaZYisCfuxmzcCiazyqz/3304a76ddd44e87762a741c23db989a5/CategorySlider_BestSellers.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/?sort=bestseller') }],
    },
    {
      title: vm.$t('the_roger_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/6me3qOaYivGlPGd0so0dSF/1b5caeba6ce5cecd7c5934a3391dd033/CategorySlider_Roger.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/roger') }],
    },
    {
      title: vm.$t('accessories'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/69vW8kvXauRUP6It1F3SPO/2ad8c877898eabf696f87fe52c3b52c2/CategorySlider_Accessories.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/accessories') }],
    },
  ]

  return CATEGORY_SLIDER_DATA
}

const HomepageService = {
  async fetch(vm) {
    const [error, result] = await to(client.query({ query: HOMEPAGE_QUERY }))
    if (error) Vue.rollbar.error(error.message, error)
    const homepage = result?.data?.homepage || {}
    if (!homepage.template) homepage.template = DEFAULT_TEMPLATE
    return {
      ...homepage,
      categorySlider: getCategorySliderData(vm, homepage.template),
    }
  },
}

export default HomepageService
